import { Navigate, Route, Routes } from 'react-router-dom';
import { PageSignIn } from './containers';

export const AuthenticationRoutes = () => {
  return (
    <Routes>
      <Route path="/login" element={<PageSignIn />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};
